import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/global';
import { Services } from 'src/app/services/api.service';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-voting-upload-image',
  templateUrl: `${environment.pageFolder}/voting-upload-image.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/voting-upload-image.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule]
})
export class VotingUploadImageComponent {
  loader = document.getElementById("loader-container")!;
  imageChangedEvent: any;
  imageBase64: any;
  errorMessage: string = "";

  constructor(private apiServices: Services, private router: Router, private readonly errorMessageService: ErrorMessageService) { }

  ngOnInit() {
    this.loader.style.display = "none";
    if(!GlobalConstants.isAuth || (localStorage.getItem("pinVerified") !== "true")) { 
      this.router.navigate(['/izbori']);
    }
  }

  fileChangeEvent(event: any): void {
    const fileInput = event.target;
    if (fileInput.files && fileInput.files[0]) {
      const fileName = fileInput.files[0].name;
      const allowedExtensions = ['.jpg', '.jpeg', '.png', '.bmp', '.webp', '.svg'];
      const fileExtension = fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2);
      if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`)) {
        this.errorMessage = "Odabrani format fotografije nije moguće učitati. Molimo Vas da učitate fotografiju u nekom od idućim formata: '.jpg', '.jpeg', '.png', '.bmp', '.webp', '.svg'."
        return;
      }
      
      this.errorMessage = "";
      const fileReader = new FileReader();
      fileReader.onloadend = (e: any) => {
        /* this.imageBase64 = e.target.result; */

        const base64String = fileReader.result as string;
        const image = new Image();
        image.src = base64String;
        image.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxWidth = 1000;
          const maxHeight = 1000;
          let newWidth = image.width;
          let newHeight = image.height;
  
          if (newWidth > maxWidth || newHeight > maxHeight) {
            if (newWidth > newHeight) {
              newHeight = Math.round((newHeight * maxWidth) / newWidth);
              newWidth = maxWidth;
            } else {
              newWidth = Math.round((newWidth * maxHeight) / newHeight);
              newHeight = maxHeight;
            }
          }
  
          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx!.drawImage(image, 0, 0, newWidth, newHeight);
  
          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.9);

          this.imageBase64 = compressedBase64
        }
      };

      fileReader.readAsDataURL(fileInput.files[0]);

    }
  }

  sendImage() {
    let votingAgreement = document.getElementById("voting-agreement")! as HTMLInputElement;

    if(!votingAgreement.checked) {
      (votingAgreement.nextElementSibling! as HTMLElement).style.backgroundColor = "#ed0000";
      this.errorMessage = "Potrebno je prihvatiti uvjet!"
    } else {
      let body = {
        document: this.imageBase64.split("data:image/jpeg;base64,")[1],
        privola: votingAgreement.checked ? "D" : "N"
      }
      this.loader.style.display = "flex";
      this.apiServices.sendImageService(body).subscribe({
       next: (data: any) => {
         this.loader.style.display = "none";
         localStorage.removeItem("pinVerified");
         this.router.navigate(['/izbori/lista']);
         sessionStorage.setItem("uploadedImage", "true");
       }, error: (error: { status: number; }) => {
         this.loader.style.display = "none";
         this.errorMessage = this.errorMessageService.getErrorMessage("error");
       }
     });
    }
  }

  removeImage() {
    this.imageBase64 = null;
    this.errorMessage = "";
    let fileInput = document.getElementById('image-upload') as HTMLInputElement;
    fileInput.value = "";
  }

  checkValue(event:any) {   
    if(event.target.checked) {
      event.target.nextElementSibling.style.backgroundColor = "#012641c4";
      this.errorMessage = "";
    } else {
      event.target.nextElementSibling.style.backgroundColor = "#e6e6e6";
    }
  }
}
